import React, { useEffect } from "react";

import { OutlinedInput, Select } from "@material-ui/core";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import { ErrorText } from "../../../widgets";
import { CONTACT_MODE } from "../../../constants";
import {
  validateNumber,
  check_url_whatsapp,
  check_url_telegram,
} from "utils/validations";
import style from "../style.module.css";
import { timezone_constants } from "constants/timezones/constants";
import { getWhatsappUrl } from "../utils";

export const ContactInfo = (props) => {
  const {
    state,
    setState,
    setField,
    errorState,
    setErrorMessage,
    errorHandlerToggle,
    disableAllEdits,
  } = props;

  //Setting default country code
  const defaultCountry =
    state.country_code == timezone_constants.country_dial_code.us
      ? timezone_constants.country_key.us
      : timezone_constants.country_key.in;

  // Set default contact mode to WhatsApp if missing and phone number exists
  useEffect(() => {
    if (!state?.social_info?.contact_mode && state?.phone_number) {
      setState({
        ...state,
        social_info: {
          ...state.social_info,
          contact_mode: CONTACT_MODE.WHATSAPP,
          contact_url: getWhatsappUrl({
            countryCode: state.country_code,
            phoneNumber: state.phone_number,
          }),
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="tw-my-1">
        <p className="tw-text-[12px] tw-text-[#27252270]">
          This will appear as a floating button on your webpage. People can
          contact you through this mode of contact.
        </p>
      </div>
      <div className={style.fieldContainer}>
        <div className={`${style.label} ${style.required}`}>Phone Number</div>
        <div className={style.field}>
          <PhoneInput
            country={defaultCountry}
            onlyCountries={[
              timezone_constants.country_key.us,
              timezone_constants.country_key.in,
            ]}
            placeholder="Enter your Phone/WhatsApp number"
            value={`${state.country_code}${state.phone_number}`}
            onChange={(phone, code) => {
              const urlFromPhoneNumber = getWhatsappUrl({
                countryCode: `+${code?.dialCode}`,
                phoneNumber: phone?.slice(code?.dialCode?.length),
              });

              // Calling setField multiple times will overwrite the immediately previous value updates
              setState({
                ...state,
                country_code: `+${code?.dialCode}`,
                country: code?.name,
                phone_number: phone?.slice(code?.dialCode?.length), // Removed the country code from the beginning
                social_info: {
                  ...state.social_info,

                  ...(state?.social_info?.contact_mode ===
                    CONTACT_MODE.WHATSAPP && {
                    contact_url: urlFromPhoneNumber,
                  }),
                },
              });

              setErrorMessage(
                "phone_number",
                validateNumber(
                  phone?.slice(code?.dialCode?.length),
                  `+${code?.dialCode}`
                )
                  ? "Invalid phone number"
                  : null
              );
            }}
            {...errorHandlerToggle("phone_number", {
              noFocus: true,
            })}
            buttonStyle={{
              borderRadius: "8px 0 0 8px",
              width: "44px",
            }}
            countryCodeEditable={false}
            inputStyle={{ width: "100%" }}
            copyNumbersOnly={false}
            autoFormat={false}
            inputProps={{
              name: "phone",
            }}
            disabled={disableAllEdits}
          />
        </div>
        <ErrorText errorState={errorState} fieldKey="phone_number" />
      </div>

      <div className={style.fieldContainer}>
        <div className={style.label}>Mode of contact</div>

        <Select
          native
          fullWidth
          variant="outlined"
          className={style.field}
          value={state?.social_info?.contact_mode}
          disabled={disableAllEdits}
          onChange={(e) => {
            setState({
              ...state,
              social_info: {
                ...state?.social_info,
                contact_mode: e.target.value,
                ...(e.target.value === CONTACT_MODE.WHATSAPP && {
                  contact_url: getWhatsappUrl({
                    countryCode: state.country_code,
                    phoneNumber: state.phone_number,
                  }),
                }),
                ...([
                  CONTACT_MODE.TELEGRAM,
                  CONTACT_MODE.NONE,
                  CONTACT_MODE.DESELECT,
                ].includes(e.target.value) && {
                  contact_url: "",
                }),
              },
            });
            setErrorMessage("contact_url", null);
          }}
        >
          <option />
          <option value={CONTACT_MODE.NONE}>
            Don&apos;t want to be contacted
          </option>
          <option value={CONTACT_MODE.ONLY_BOOKED_USER}>
            Only allow booked users to contact me
          </option>
          <option value={CONTACT_MODE.WHATSAPP}>WhatsApp</option>
          <option value={CONTACT_MODE.TELEGRAM}>Telegram</option>
        </Select>
      </div>

      {[CONTACT_MODE.WHATSAPP, CONTACT_MODE.TELEGRAM].includes(
        state?.social_info?.contact_mode
      ) ? (
        <div className={style.fieldContainer}>
          <div className={`${style.label} ${style.required}`}>Contact URL</div>
          <div className={style.field}>
            <OutlinedInput
              className={style.input}
              value={state?.social_info?.contact_url}
              name="contact_url"
              multiline
              rows={2}
              onChange={(e) => {
                setField(["social_info", "contact_url"], e.target.value);
                let errVal = null;
                if (
                  state?.social_info?.contact_mode !== CONTACT_MODE.NONE &&
                  e.target?.value?.length === 0
                ) {
                  errVal = `Please provide a ${state?.social_info?.contact_mode} URL`;
                } else if (
                  state?.social_info?.contact_mode === CONTACT_MODE.WHATSAPP
                ) {
                  errVal = check_url_whatsapp(e.target.value);
                } else if (
                  state?.social_info?.contact_mode === CONTACT_MODE.TELEGRAM
                ) {
                  errVal = check_url_telegram(e.target.value);
                }
                setErrorMessage("contact_url", errVal);
              }}
              {...errorHandlerToggle("contact_url", {
                noFocus: true,
              })}
              disabled={disableAllEdits}
            />
          </div>
          {state?.social_info?.contact_mode === "Whatsapp" &&
          state?.social_info?.contact_url.includes("+") ? (
            <div className={style.info}>
              For WhatsApp contact URLs, a <span>+</span>
              &nbsp;sign before the country code might cause the link to be
              invalid. Kindly check the link once before saving.
            </div>
          ) : null}
          <ErrorText errorState={errorState} fieldKey="contact_url" />
        </div>
      ) : null}
    </>
  );
};
